module.exports = __webpack_public_path__ + "static/media/text.b7859ad2.svg";